import { Disclosure } from "@headlessui/react";
import ChevronRight from "@material-ui/icons/ChevronRight";
import type { DigitalAsset } from "../types";

interface BingSectionProps {
  asset: DigitalAsset;
}

const BingSection = ({ asset }: BingSectionProps) => (
  <Disclosure defaultOpen>
    {({ open }) => (
      <div className="bg-white rounded-lg box-shadow">
        <Disclosure.Button className="disclosureBtn ml-2">
          <ChevronRight
            className={`${
              open ? "transform rotate-90" : " text-gray-500"
            } text-gray-500 w-5 h-5 `}
          />
          <span className="disclosureLabel ml-2">Bing</span>
        </Disclosure.Button>

        <Disclosure.Panel className="text-xs">
          <div className="grid grid-cols-2">
            <div className="p-2">
              <div className="grid grid-cols-1 p-2">
                <label className="mx-4 expandedLabel fontExpand">
                  Bing URL:
                </label>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  className="mx-4 expandedData fontExpand text-blue-500 underline break-all self-center"
                  href={asset.bing && asset.bing !== "NULL" ? asset.bing : ""}
                >
                  {asset.bing && asset.bing !== "NULL" ? asset.bing : ""}
                </a>
              </div>
            </div>

            <div className="p-2">
              <div className="grid grid-cols-1 p-2">
                <label className="mx-4 expandedLabel fontExpand">
                  Bing Description:
                </label>
                <div className="mx-4 expandedData fontExpand">
                  {asset.bingDescription && asset.bingDescription !== "NULL"
                    ? asset.bingDescription
                    : ""}
                </div>
              </div>
            </div>
          </div>
        </Disclosure.Panel>
      </div>
    )}
  </Disclosure>
);

export default BingSection;